import React from 'react';

import { useIntl } from 'react-intl';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar/toolbar-dropdown-item';
import AiGenerativeRemixIcon from '@atlaskit/icon-lab/core/ai-generative-remix';

type RemixPasteMenuItemProps = {
	onClick: (event: React.SyntheticEvent<Element>) => void;
};

export const RemixPasteMenuItem = ({ onClick }: RemixPasteMenuItemProps): JSX.Element => {
	const intl = useIntl();
	return (
		<ToolbarDropdownItem
			testId="ai-paste-menu__remix"
			elemBefore={<AiGenerativeRemixIcon size="small" label="" />}
			onClick={onClick}
		>
			{intl.formatMessage(aiConfigItemMessages.remixTitle)}
		</ToolbarDropdownItem>
	);
};
